import React from 'react';
import { CaretUpOutlined, CaretDownFilled } from '@ant-design/icons';

interface HeaderCountPercentageProps {
  total: number;
  percentage: string;
  upDownStatus: number;
  title?: string;  // Optional prop
}

function HeaderCountPercentage({ total, percentage, upDownStatus , title }: HeaderCountPercentageProps) {
  return (
    <div className="d-flex justify-content-between position-absolute w-100 top-0 end-0 p-2 header-percentage-container">
      <h6>{title ? `${total} ${title}` : total}</h6>
      <div className="d-flex gap-1 align-items-center">
        {upDownStatus > 0 ? (
          <CaretUpOutlined className="percentage-up" />
        ) : upDownStatus < 0 ? (
          <CaretDownFilled className='percentage-down' />
        ) : null}
        <h6>{percentage}</h6>
      </div>
    </div>
  );
}

export default HeaderCountPercentage;
